export default "__VITE_ASSET__C4DMHX3Y__"